<template>
  <div>
    <v-layout wrap>
      <v-flex md12 lg12 xs12 sm12 xl12>
        <v-carousel height="100%" hide-delimiters
        >
          <v-carousel-item v-for="(item,i) in photos" :key="i">
        <v-img contain :src="require('../../assets/tor1.jpg')">
           <Header3 /> 
          <v-layout wrap fill-height pb-lg-10 pb-md-10 class="d-none d-sm-flex">
            <v-flex align-self-end text-left xs12 sm6 md5 pb-md-1>
              <div class="rectangle2">
                <v-layout wrap justify-center>
                  <v-flex pl-lg-8 class="d-none d-sm-flex">
                    <span class="bannernotXStriangle1">
                      A citizen science initiative to record the turtle
                      biodiversity present in India 
                    </span>
                  </v-flex>
                  <v-flex pl-lg-8 class="hidden-sm-and-up">
                    <span class="bannerXStriangle1">
                      A citizen science initiative to record the turtle
                      biodiversity present in India 
                    </span>
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>
            <!-- <v-flex md2 align-self-center>
                    <div></div>
                  </v-flex> -->
            <!-- <v-flex text-center align-self-end md2 >
                    <v-layout wrap>
                    <v-flex  class="triangle-right1"> 
                      <v-layout wrap >
                        <v-flex md10 >
                      <span style="font-size:23px;" >
                        To learn more about us
                      </span> 

                        </v-flex>
                      </v-layout>               
                    </v-flex>
                    
                    </v-layout>
                  </v-flex> -->
            <!-- <v-flex md1 align-self-end>
                    <div  class="triangle-right2"></div>
                  </v-flex> -->
            <!-- <v-flex xs5 sm2 md2 lg1 pb-md-8 align-self-end text-left>
                <v-layout wrap>
                  <v-flex class="triangle-rights"></v-flex>
                </v-layout>
              </v-flex> -->
            <!-- <v-flex xs4 sm2 md2 lg2 pb-md-8 align-self-end>
                <v-layout wrap justify-center>
                  <v-flex
                    align-self-center
                    py-lg-3
                    pt-md-2
                    text-left
                    class="rectangles d-none d-sm-flex"
                  >
                    <span class="bannernotXStriangle2">
                      To learn more <br>about us
                    </span>
                  </v-flex>
                  <v-flex
                    align-self-center
                    py-lg-3
                    pt-5
                    text-left
                    class="rectangles hidden-sm-and-up"
                  >
                    <span class="bannerXStriangle2">
                      To learn more about us
                    </span>
                  </v-flex>
                </v-layout>
              </v-flex> -->
            <v-flex lg1 align-self-end>
              <v-layout wrap justify-center>
                <v-flex class="triangle-rights3"></v-flex>
              </v-layout>
            </v-flex>
          </v-layout>

          <!-- <v-layout wrap fill-height >
                  <v-flex align-self-end md12 pl-12 style="background-color: #A0DAA9;  ">
                    <div  class="triangle-right2"></div>
                  </v-flex>
                  <v-flex  md2 >
                    <div  class="rectangle2"></div>

                  </v-flex>
                  <v-flex md3 align-self-center>
                    <div  class="triangle-right2"></div>

                  </v-flex>
                  <v-flex md2 align-self-center>
                    <div></div>
                  </v-flex>
                </v-layout> -->
        </v-img>
        </v-carousel-item>
        </v-carousel>
        <v-layout justify-end class="hidden-sm-and-up">
          <v-flex align-self-end text-center xs12>
            <p class="bannerXSRECT1">
              <span>
                A citizen science initiative to record the turtle biodiversity
                present in India 
              </span>
            </p>
            <!-- <v-btn
                min-width="100%"
                class="text-capitalize"
                color="rgba(49, 101, 221, 0.56)"
                style="opacity:0.8;">
                  <span class="bannerXSRECT2">
                      To learn more about us
                    </span>
                </v-btn> -->
          </v-flex>
          <v-flex align-self-center> </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Header3 from "../Header3";
export default {
  components: {
     Header3,
  },
  data(){
    return{
      photos:['1','2',"3"]
    }
  }
};
</script>

<style>
.rectangle2 {
  height: 100px;
  width: 100%;
  padding: 2%;
  background-color: rgba(255, 191, 0, 0.7);
  opacity: 0.8;
}
/* .triangle-right1 {
  width: 0;
  height: 0;
  border-top: 35px solid #3165dd;
  border-left: 50px solid #ffbf00;
  border-bottom: 35px solid #3165dd;
  background-color: #3165dd;
  opacity: 0.8;
} */
/* .triangle-right2 {
  width: 0;
  height: 0;
  border-top: 35px solid transparent;
  border-left: 50px solid #3165dd;
  border-bottom: 35px solid transparent;
  opacity: 0.8;
} */

.triangle-rights {
  width: 0;
  height: 0;
  border-top: 45px solid rgba(49, 101, 221, 0.16);
  border-left: 100px solid rgba(255, 191, 0, 0.94);
  border-bottom: 45px solid rgba(49, 101, 221, 0.16);
  opacity: 0.8;
  background-color: rgba(49, 101, 221, 0.56);
}
.triangle-rights2 {
  width: 0;
  height: 0;
  border-top: 45px solid transparent;
  border-left: 90px solid rgba(49, 101, 221, 0.66);
  border-bottom: 45px solid transparent;
  opacity: 0.8;
}
.triangle-rights3 {
  width: 0;
  height: 0;
  border-top: 55px solid transparent;
  border-left: 90px solid rgba(255, 191, 0, 0.7);
  border-bottom: 50px solid transparent;
  opacity: 0.8;
}
.rectangles {
  height: 90px;
  width: 200px;
  background-color: rgba(49, 101, 221, 0.66);
  opacity: 0.8;
}
</style>